import { useFormikContext } from "formik"
import { shapes, metaobject, getSrcSet, getImageSizes, sectionSettings, configuratorOptions } from "../../Helpers/WindowHelpers";
import ConfiguratorValue from "../../Interfaces/ConfiguratorValue";
import DimensionDisplay from "./DimensionDisplay";
import Heading from "../Heading";
import FormikValueList from "./FormikValueList";
import Image from "./Image";

interface CadModelDisplayInterface {

}

const CadModelDisplay = ({ }: CadModelDisplayInterface) => {
    const context = useFormikContext<any>();
    const currentShape = shapes?.find((shape) => shape.shape_id == context.values?.shape);
    const foldDirection = currentShape?.panels?.find((panel) => panel.number_of_panels == context.values?.panels)?.fold_directions?.find((fold) => fold.option_select_name == context.values?.fold_direction);
    const strapLocation = foldDirection?.strap_locations?.find((strap) => strap.option_select_name == context.values?.strap_location);
    const coverInput = document.querySelector('input.configurator_variant:checked') as HTMLInputElement;
    const variantTaperImage = [...document.querySelectorAll('.js-variant-image')]?.find((item) => item.getAttribute('data-variant-id') == coverInput?.value) as HTMLElement
    const srcSets = [400, 800];
    const imageSizes = getImageSizes('400px', []);
    const valueList = configuratorOptions;
    const upgradesOption = configuratorOptions.find((item) => item.value == 'upgrades');
    return (
        <div className="configurator-cad d--flex sm--flex-column sm--align-items--center flex-center py-20 bg-color--blue-light relative">
            <div className="configurator-display__cad">
                <div className="configurator-display__layer">
                    {window.watermark.src && (
                        <Image image={window.watermark} srcSet={srcSets} sizes={imageSizes} />
                    )}
                </div>
                <div className="configurator-display__layer ">
                    <DimensionDisplay dimension="a" currentShape={currentShape} />
                    <DimensionDisplay dimension="b" currentShape={currentShape} />
                    <DimensionDisplay dimension="c" currentShape={currentShape} />
                    <DimensionDisplay dimension="d" currentShape={currentShape} />
                    <div className="configurator-display__shape">
                        <img
                            srcSet={getSrcSet(currentShape ? currentShape.image.src : metaobject.shape_placeholder_image, srcSets)}
                            sizes={imageSizes}
                            loading="lazy"
                            alt={currentShape ? currentShape.name : "Shape Placeholder Image. Please select a shape."}
                        />
                    </div>
                </div>
                <div className="configurator-display__layer configurator-display__fold-direction">
                    {foldDirection && foldDirection.image.src ? (
                        <Image image={foldDirection.image} srcSet={srcSets} sizes={imageSizes} />
                    ) : null}
                </div>
                <div className="configurator-display__layer configurator-display__strap-location">
                    {strapLocation && strapLocation.image.src ? (
                        <Image image={strapLocation.image} srcSet={srcSets} sizes={imageSizes} />
                    ) : null}
                </div>
                <div className="configurator-display__layer configurator-display__handles">
                    {foldDirection && foldDirection.default_handle_location.src ? (
                        <Image image={foldDirection.default_handle_location} srcSet={srcSets} sizes={imageSizes} />
                    ) : null}
                </div>
            </div>
            <div className="d--flex flex-column justify--center gap-10 px-20">
                <Heading
                    level={4}
                    text={"Details"}
                />
                <div className="cad__list">
                    <ul>
                        <li>{sectionSettings.label_cad_product} {coverInput.dataset.configuratorProductTitle}</li>
                        <li>{sectionSettings.label_cad_variant} {coverInput.dataset.configuratorTitle}</li>
                    </ul>
                </div>
                <FormikValueList
                    items={valueList}
                    context={context}
                    hidePrice={true}
                    classes="cad__list"
                />
                {context.values?.variants?.some((item: ConfiguratorValue) => item.field == "upgrades") && <>
                    <Heading
                        level={4}
                        text={metaobject.text.upgrades_heading}
                    />
                    <FormikValueList
                        items={[upgradesOption]}
                        context={context}
                        hidePrice={true}
                        classes="cad__list"
                    />
                </>}
            </div>
        </div>
    );
}

export default CadModelDisplay;